import { LaravelResponse, createCrudService, keyToUrl } from "@dgs/core";
import { RoleCreateDto, RoleListDto, RoleOptionDto, RoleShowDto, RoleUpdateDto } from "apiGen";
import axios from "axios";
import { IPermission } from "~shared/types/permission";

export const roleService = createCrudService<RoleListDto, RoleOptionDto, RoleShowDto, RoleCreateDto, RoleUpdateDto>([
	"roles",
]);

export const permissionService = {
	indexKey: ["permissions"],
	index: () => axios.get<LaravelResponse<IPermission[]>>(keyToUrl(["permissions"])),
};
